import { render, staticRenderFns } from "./BindUser.vue?vue&type=template&id=37f44756&scoped=true&"
import script from "./BindUser.vue?vue&type=script&lang=js&"
export * from "./BindUser.vue?vue&type=script&lang=js&"
import style0 from "./BindUser.vue?vue&type=style&index=0&id=37f44756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f44756",
  null
  
)

export default component.exports